let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dulRf")).then(() => parcelRequire('blpFJ'));